// ============================================
// SECTION — HowItWorks
// ============================================

import {
  RiCalendarCheckLine,
  RiCheckboxCircleLine,
  RiRocketLine,
  RiFileChartLine,
} from "react-icons/ri";
import { HOW_STEPS } from "../data/content";
import { useInView } from "../hooks/useInView";
import "./HowItWorks.css";

const ICON_MAP = {
  calendar: <RiCalendarCheckLine />,
  check:    <RiCheckboxCircleLine />,
  rocket:   <RiRocketLine />,
  chart:    <RiFileChartLine />,
};

export default function HowItWorks() {
  const [ref, visible] = useInView(0.1);

  return (
    <section id="how" className="how section-pad">
      <div className="container">
        <div className={`fade-up ${visible ? "visible" : ""}`}>
          <span className="section-label how__label">Simple Process</span>
          <h2 className="section-title how__title">How It Works</h2>
          <p className="section-sub how__sub">
            From first contact to lasting impact — here&apos;s exactly what to expect.
          </p>
        </div>

        <div ref={ref} className="how__steps">
          {/* Connector line */}
          <div className="how__line" />

          {HOW_STEPS.map((step, i) => (
            <div
              key={step.label}
              className={`how__step stagger-child ${visible ? "visible" : ""}`}
              style={{ transitionDelay: `${i * 0.15}s` }}
            >
              <div className="how__step-bubble">
                <span className="how__step-icon">{ICON_MAP[step.iconKey]}</span>
                <span className="how__step-num">{i + 1}</span>
              </div>
              <h3 className="how__step-label">{step.label}</h3>
              <p className="how__step-desc">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
